import {match} from 'ts-pattern';

import type {EagColumn} from '../types/EagColumn';
import {toPlainLabel} from './toPlainLabel';

type RawCell = {value: unknown; style?: Record<string, unknown>; id?: string} | null | undefined;
type ImageCellValue = {url?: string} | null | undefined;

export const getValueFromRawCell = (column: EagColumn, rawCell: unknown): unknown => {
  if (rawCell === null || rawCell === undefined) {
    return rawCell;
  }

  const cell = rawCell as RawCell;

  return (
    match(column.type)
      // FLAG renderer receives the whole raw cell: needs both .value.label and .style.flagColor
      .with('FLAG', () => rawCell)
      // THUMBNAIL: extract the URL string from the nested value object {url: "..."}
      .with('THUMBNAIL', () => {
        const imageValue = cell?.value as ImageCellValue;
        return imageValue?.url ?? null;
      })
      // ICON renderer expects the display label string: TEXT columns store it in
      // .value directly, ENUM columns wrap it in {key, label} — singly or as an
      // isArray array (the icon itself comes from the cell's style.icon, not
      // from the value). toPlainLabel extracts/joins the labels; null (not '')
      // preserves the renderer's missing-label fallback.
      .with('ICON', () => {
        const iconValue = cell?.value;
        if (typeof iconValue === 'object' && iconValue !== null) {
          const label = toPlainLabel(iconValue);
          return label === '' ? null : label;
        }
        return iconValue;
      })
      // All other types: extract .value from the wrapper object
      .otherwise(() => cell?.value)
  );
};
